<template>
  <div>
    <v-dialog v-model="dialog" max-width="700">
      <v-card class="pa-3">

        <v-form>
          <div class="ma-2">

            <span class="title" v-if="!card">Add Card</span>
            <span class="title" v-if="card">Edit Card</span>
            <v-btn class="float-right" @click="dialog = false" icon><v-icon>mdi-close</v-icon></v-btn>
          </div>

          <v-tabs v-if="!cardType" color="blue" v-model="questionType" :left="true" class="mx-0">
            <v-tab class="mx-0">Q and A</v-tab>
            <v-tab >Occlusion</v-tab>
            <v-tab >Labeled Image</v-tab>
          </v-tabs>
          <div class="my-5">
          </div>
          <CardTypeQA ref="cardTypeQAref" @saveCard="saveCard" @editCard="updateCard" v-if="cardType == 'question_answer' || questionTypeEnum[questionType] == 'question_answer'" :card = "card"/>
          <CardTypeOcclusion v-if="cardType == 'occlusion' || questionTypeEnum[questionType] == 'occlusion'" :card = "card"/>
          <CardTypeLabeledImage ref="cardTypeLabeledImageref" @saveCard="saveCard" @editCard="updateCard" v-if="cardType == 'labeled_image' || questionTypeEnum[questionType] == 'labeled_image'" :card = "card"/>
          <p class="red--text">{{error}}</p>
          <v-btn right icon v-if="card" @click="deleteCard">
            <v-icon color="grey darken-1">mdi-delete</v-icon>
          </v-btn>
          <v-btn right icon v-if="!card" >
            <v-icon color="white">mdi-user</v-icon>
          </v-btn>
        </v-form>
      </v-card>
    </v-dialog>
  </div>

</template>
<script>
import CardTypeQA from '@/components/CardTypeQA.vue'
import CardTypeOcclusion from '@/components/CardTypeOcclusion.vue'
import CardTypeLabeledImage from '@/components/CardTypeLabeledImage.vue'
import db from '@/fb'
import firebase from 'firebase'
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'EditCard',
  components: {
    CardTypeQA,
    CardTypeOcclusion,
    CardTypeLabeledImage
  },
  props: ['card'],
  watch: {
    card() {
      this.preEditCopy = null //used to clear old copy
      if (this.card != null) {
        console.log(this.card)

        //create a copy of the card before any editting occurs
        this.preEditCopy = Object.assign({}, this.card)
        this.preEditCopy.editTime = null // create field for record
        this.preEditCopy.editorMakingNewUpdate =  firebase.auth().currentUser.uid

      }
      else {
        console.log('loaded')
      }
    }
  },
  data() {
    return {
      dialog: false,
      questionType: 0,
      questionTypeEnum: {
        0: 'question_answer',
        1: 'occlusion',
        2: 'labeled_image'
      },
      error: null,
      loading: false,
      preEditCopy: null,
    }
  },
  computed: {
    cardType() {
      if (this.card) {
        return this.card.type
      }
      else {
        return null
      }
    }
  },
  mounted() {
    console.log('mounted')
  },
  methods: {
    openDialog() {
      this.dialog = true
    },
    saveCard(localCard) {
      this.loading = true
      localCard.deck = this.$route.params.id
      firebase.firestore().collection('cards').doc().set(localCard)
      .then(result => {
        this.dialog = false
        this.loading = false
        this.$emit('reloadCards')

        //confirmation message from snackbar which lives in global component
        this.$store.commit('snackbarMessageSet', {
          color: 'green lighten-1',
          message: 'Saved new card.'
        })

      }).catch(err => {
        this.loading = false
        //confirmation message from snackbar which lives in global component
        this.$store.commit('snackbarMessageSet', {
          color: 'red lighten-1',
          message: err
        })

      })
    },
    updateCard(localCard) {
      this.loading = true
      console.log("localCard:", localCard)
      let copy = Object.assign({}, localCard);
      delete copy.id
      copy.lastEditor =  firebase.auth().currentUser.uid //flag person making change
      console.log("copy:", copy)

      //set new unique identifier for the changed card
      copy.identifier = uuidv4()

      //record time of edit
      this.preEditCopy.editTime = new Date()

      //store content history
      firebase.firestore().collection('contentHistory').doc(this.$route.params.id).collection('cardEdits').doc().set(this.preEditCopy)

      firebase.firestore().collection('cards').doc(localCard.id).update(copy)
      .then(result => {
        this.dialog = false
        this.loading = false
        this.$emit('reloadCards')

        //confirmation message from snackbar which lives in global component
        this.$store.commit('snackbarMessageSet', {
          color: 'green lighten-1',
          message: 'Saved card update.'
        })

      }).catch(err => {
        this.loading = false
        //confirmation message from snackbar which lives in global component
        this.$store.commit('snackbarMessageSet', {
          color: 'red lighten-1',
          message: err
        })
      })
    },
    deleteCard() {
      confirm("Delete this card?")
      console.log(this.card)
      firebase.firestore().collection('cards').doc(this.card.id).delete()
      .then(result => {
        this.dialog = false
        this.loading = false
        this.$emit('reloadCards')

        //confirmation message from snackbar which lives in global component
        this.$store.commit('snackbarMessageSet', {
          color: 'green lighten-1',
          message: 'Card successfullly deleted.'
        })

      }).catch(err => {
        this.loading = false
        //confirmation message from snackbar which lives in global component
        this.$store.commit('snackbarMessageSet', {
          color: 'red lighten-1',
          message: err
        })
      })
    }
  }
}
</script>
<style>

</style>
